function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2012(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 21.95,
    height: 8.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2614285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 4.415
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8.83,
    width: 21.95,
    height: 11.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 14.735
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20.64,
    width: 21.95,
    height: 19.55,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2583333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 30.415
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40.19,
    width: 21.95,
    height: 23.3,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.658333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 51.839999999999996
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 63.5,
    width: 21.95,
    height: 25.1,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4388888888888887
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 76.05
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 88.6,
    width: 21.95,
    height: 25.91,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.39
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 101.55499999999999
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 114.51,
    width: 21.95,
    height: 26.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.39
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 127.875
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 141.24,
    width: 21.95,
    height: 27.95,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.4875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 155.215
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 169.19,
    width: 21.95,
    height: 28.38,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.39
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 183.38
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 197.57,
    width: 21.95,
    height: 32.2,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.195
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 213.67
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 229.77,
    width: 21.95,
    height: 32.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.195
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 246.245
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 262.72,
    width: 21.95,
    height: 33.5,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1357142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 279.47
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 296.22,
    width: 21.95,
    height: 37.18,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.658333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 314.81
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 333.4,
    width: 21.95,
    height: 38.44,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.39
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 352.62
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 371.84,
    width: 21.95,
    height: 38.47,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.74375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 391.075
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 410.31,
    width: 21.95,
    height: 40.8,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.658333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 430.71
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 451.11,
    width: 21.95,
    height: 46.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.658333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 474.52000000000004
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 497.94,
    width: 21.95,
    height: 50.1,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1357142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 522.99
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 548.04,
    width: 21.95,
    height: 50.15,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.658333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 573.115
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 598.19,
    width: 21.95,
    height: 50.34,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.658333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 623.36
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 648.53,
    width: 21.95,
    height: 51.47,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.4875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.975,
    y: 674.265
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.95,
    y: 0,
    width: 30.88,
    height: 37.88,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.807272727272727
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.39,
    y: 18.94
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.83,
    y: 0,
    width: 31.35,
    height: 37.88,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.91875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.505,
    y: 18.94
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.18,
    y: 0,
    width: 31.69,
    height: 37.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.527142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 100.025,
    y: 18.94
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.87,
    y: 0,
    width: 32.24,
    height: 37.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.224
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.99,
    y: 18.94
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.12,
    y: 0,
    width: 32.32,
    height: 37.88,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.464
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.28,
    y: 18.94
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.43,
    y: 0,
    width: 32.45,
    height: 37.88,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.605555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.655,
    y: 18.94
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.89,
    y: 0,
    width: 36.2,
    height: 37.88,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 230.98999999999998,
    y: 18.94
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.09,
    y: 0,
    width: 36.32,
    height: 37.88,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.053333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.25,
    y: 18.94
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.42,
    y: 0,
    width: 36.94,
    height: 37.88,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 303.89,
    y: 18.94
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.36,
    y: 0,
    width: 40.64,
    height: 37.88,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.735
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.68,
    y: 18.94
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 363,
    y: 0,
    width: 45.81,
    height: 37.88,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.3133333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 385.905,
    y: 18.94
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.81,
    y: 0,
    width: 47.95,
    height: 37.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.411428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 432.785,
    y: 18.94
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 456.76,
    y: 0,
    width: 48.13,
    height: 37.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1566666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 480.825,
    y: 18.94
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.89,
    y: 0,
    width: 48.27,
    height: 37.88,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.3133333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 529.025,
    y: 18.94
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 553.16,
    y: 0,
    width: 48.41,
    height: 37.88,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.5760000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 577.365,
    y: 18.94
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 601.57,
    y: 0,
    width: 49.06,
    height: 37.88,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 626.1,
    y: 18.94
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 650.63,
    y: 0,
    width: 49.37,
    height: 37.88,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.20888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.3149999999999,
    y: 18.94
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.95,
    y: 37.88,
    width: 49.14,
    height: 39.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.945
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.519999999999996,
    y: 57.77
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.95,
    y: 77.66,
    width: 49.14,
    height: 40.06,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.519999999999996,
    y: 97.69
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.95,
    y: 117.72,
    width: 49.14,
    height: 40.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.008
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.519999999999996,
    y: 137.76
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.95,
    y: 157.8,
    width: 49.14,
    height: 42.29,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.048333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.519999999999996,
    y: 178.94500000000002
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.95,
    y: 200.09,
    width: 49.14,
    height: 42.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.3725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.519999999999996,
    y: 221.58
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.95,
    y: 243.07,
    width: 49.14,
    height: 45.58,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.596666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.519999999999996,
    y: 265.86
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.95,
    y: 288.64,
    width: 49.14,
    height: 45.75,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.519999999999996,
    y: 311.515
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.95,
    y: 334.39,
    width: 49.14,
    height: 46.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.232
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.519999999999996,
    y: 357.46999999999997
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.95,
    y: 380.55,
    width: 49.14,
    height: 47.85,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9750000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.519999999999996,
    y: 404.475
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.95,
    y: 428.4,
    width: 49.14,
    height: 52.28,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.1425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.519999999999996,
    y: 454.53999999999996
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.95,
    y: 480.68,
    width: 49.14,
    height: 53.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.38
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.519999999999996,
    y: 507.505
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.95,
    y: 534.33,
    width: 49.14,
    height: 53.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.1425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.519999999999996,
    y: 561.1600000000001
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.95,
    y: 587.99,
    width: 49.14,
    height: 54.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.19
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.519999999999996,
    y: 615.135
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.95,
    y: 642.28,
    width: 49.14,
    height: 57.72,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.0200000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.519999999999996,
    y: 671.14
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.09,
    y: 37.88,
    width: 53.52,
    height: 53.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.598571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 97.85000000000001,
    y: 64.475
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.61,
    y: 37.88,
    width: 53.72,
    height: 53.19,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.91
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 151.47,
    y: 64.475
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.33,
    y: 37.88,
    width: 55.15,
    height: 53.19,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.91
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 205.905,
    y: 64.475
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.48,
    y: 37.88,
    width: 56.59,
    height: 53.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.598571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.775,
    y: 64.475
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.07,
    y: 37.88,
    width: 57.2,
    height: 53.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.598571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.67,
    y: 64.475
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 347.27,
    y: 37.88,
    width: 57.43,
    height: 53.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.865
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 375.98499999999996,
    y: 64.475
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404.7,
    y: 37.88,
    width: 58.05,
    height: 53.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.64875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 433.72499999999997,
    y: 64.475
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 462.74,
    y: 37.88,
    width: 58.69,
    height: 53.19,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.319
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 492.08500000000004,
    y: 64.475
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 521.43,
    y: 37.88,
    width: 58.72,
    height: 53.19,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.865
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 550.79,
    y: 64.475
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 580.15,
    y: 37.88,
    width: 59.59,
    height: 53.19,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.865
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 609.9449999999999,
    y: 64.475
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 639.74,
    y: 37.88,
    width: 60.26,
    height: 53.19,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.638
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.87,
    y: 64.475
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.09,
    y: 91.07,
    width: 61.87,
    height: 61.05,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.63125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.025,
    y: 121.595
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.09,
    y: 152.12,
    width: 61.87,
    height: 62.29,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.838571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.025,
    y: 183.26500000000001
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.09,
    y: 214.41,
    width: 61.87,
    height: 62.43,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.73375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.025,
    y: 245.625
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.09,
    y: 276.84,
    width: 61.87,
    height: 64.24,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.373999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.025,
    y: 308.96
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.09,
    y: 341.08,
    width: 61.87,
    height: 64.64,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.838571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.025,
    y: 373.4
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.09,
    y: 405.72,
    width: 61.87,
    height: 68.75,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.311666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.025,
    y: 440.095
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.09,
    y: 474.47,
    width: 61.87,
    height: 73.86,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.186999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.025,
    y: 511.40000000000003
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.09,
    y: 548.33,
    width: 61.87,
    height: 75.49,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.838571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.025,
    y: 586.075
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.09,
    y: 623.82,
    width: 61.87,
    height: 76.18,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.874444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.025,
    y: 661.9100000000001
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.96,
    y: 91.07,
    width: 62,
    height: 76.15,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.857142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.96,
    y: 129.14499999999998
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 194.97,
    y: 91.07,
    width: 65.94,
    height: 76.15,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 227.94,
    y: 129.14499999999998
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.91,
    y: 91.07,
    width: 66.29,
    height: 76.15,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.258000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 294.055,
    y: 129.14499999999998
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.2,
    y: 91.07,
    width: 69.26,
    height: 76.15,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.315
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 361.83,
    y: 129.14499999999998
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.45,
    y: 91.07,
    width: 73.34,
    height: 76.15,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.668000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 433.12,
    y: 129.14499999999998
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 469.79,
    y: 91.07,
    width: 73.46,
    height: 76.15,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.243333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 506.52000000000004,
    y: 129.14499999999998
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 543.25,
    y: 91.07,
    width: 74.83,
    height: 76.15,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.314444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 580.665,
    y: 129.14499999999998
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 618.08,
    y: 91.07,
    width: 81.92,
    height: 76.15,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.461111111111112
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 659.0400000000001,
    y: 129.14499999999998
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.96,
    y: 167.22,
    width: 83.23,
    height: 79.34,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.9175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 174.57500000000002,
    y: 206.89
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.96,
    y: 246.56,
    width: 83.23,
    height: 81.43,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 174.57500000000002,
    y: 287.275
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.96,
    y: 327.99,
    width: 83.23,
    height: 88.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.40375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 174.57500000000002,
    y: 372.275
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.96,
    y: 416.56,
    width: 83.23,
    height: 90.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 174.57500000000002,
    y: 462.035
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.96,
    y: 507.51,
    width: 83.23,
    height: 92.7,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.40375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 174.57500000000002,
    y: 553.86
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.96,
    y: 600.21,
    width: 83.23,
    height: 99.79,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 174.57500000000002,
    y: 650.105
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.19,
    y: 167.22,
    width: 91.31,
    height: 91.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.41375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.845,
    y: 212.89499999999998
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.5,
    y: 167.22,
    width: 91.39,
    height: 91.35,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 353.195,
    y: 212.89499999999998
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 398.89,
    y: 167.22,
    width: 93.89,
    height: 91.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.8375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 445.835,
    y: 212.89499999999998
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 492.77,
    y: 167.22,
    width: 99.49,
    height: 91.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.41875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 542.515,
    y: 212.89499999999998
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 592.27,
    y: 167.22,
    width: 107.73,
    height: 91.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 646.135,
    y: 212.89499999999998
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.19,
    y: 258.57,
    width: 111.78,
    height: 92.17,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.434
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 272.08,
    y: 304.655
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.19,
    y: 350.74,
    width: 111.78,
    height: 100.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.166363636363636
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 272.08,
    y: 401.15500000000003
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.19,
    y: 451.57,
    width: 111.78,
    height: 124.19,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.178
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 272.08,
    y: 513.665
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.19,
    y: 575.76,
    width: 111.78,
    height: 124.24,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.9725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 272.08,
    y: 637.88
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.97,
    y: 258.57,
    width: 95,
    height: 168,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.833333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 375.47,
    y: 342.57
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.97,
    y: 258.57,
    width: 112.69,
    height: 168,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.09857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 479.31500000000005,
    y: 342.57
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 535.66,
    y: 258.57,
    width: 164.34,
    height: 168,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.5425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 617.8299999999999,
    y: 342.57
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.97,
    y: 426.57,
    width: 178.55,
    height: 273.43,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.231818181818184
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 417.245,
    y: 563.285
  }, "\n        Mecklenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 506.52,
    y: 426.57,
    width: 193.48,
    height: 273.43,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 48.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.26,
    y: 563.285
  }, "\n        Wake\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2012);
export default __webpack_public_path__ + "static/media/2012.1c3148bffffd095aa46a23146a988fbb.svg";
export { ForwardRef as ReactComponent };